'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _catalog = require('./mock/catalog');

var _catalog2 = require('./remote/catalog');

var Catalog = {
    fetchCatalogItems: function fetchCatalogItems(params) {
        return __MOCK__ ? _catalog.CatalogMock.fetchCatalogItems(params) : _catalog2.CatalogRemote.fetchCatalogItems(params);
    },
    fetchCatalogsByIds: function fetchCatalogsByIds(params) {
        return __MOCK__ ? _catalog.CatalogMock.fetchCatalogsByIds(params) : _catalog2.CatalogRemote.fetchCatalogsByIds(params);
    },
    fetchCuratorsForCatalog: _catalog2.CatalogRemote.fetchCuratorsForCatalog,
    fetchRegisteredCatalogs: _catalog2.CatalogRemote.fetchRegisteredCatalogs,
    fetchUpcomingCatalogs: _catalog2.CatalogRemote.fetchUpcomingCatalogs,
    postCatalogItems: _catalog2.CatalogRemote.postCatalogItems,
    postRegisterForCatalog: _catalog2.CatalogRemote.postRegisterForCatalog
};

exports.default = Catalog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/catalog.js
// module id = bRXb
// module chunks = 57